// This file contains the code for showing the dataset and the table names of that dataset
// It also contains the code for UI of switching the datasets or Adding a new dataset
// and switching between the tables of the selected datset
// It is called from the DataViewerBottom component

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { palette } from '../..';
import { IndChartPropProperties } from '../../redux/ChartPoperties/ChartPropertiesInterfaces';
import {
  ICalculationInfo,
  ICurrentCalculationSession,
} from '../../redux/Calculations/CurrentCalculationSessionInterface';
import { IGetDatasetResponse } from '../../api/types/dataset';
import {
  IndTabRilePropsTablesForSelectedDatasets,
  TabTilPropsSelectedDatasetList,
} from '../../redux/TabTile/TabTilePropsInterfaces';

interface DatasetAndTableListProps {
  savedCalculations: ICurrentCalculationSession[];
  selectedDataSetId: string;
  handleDataSetChange: (e: string) => void;
  handleTableChange: (
    table:
      | IGetDatasetResponse['dataSchema']['tables'][0]
      | IndTabRilePropsTablesForSelectedDatasets,
    isExtract?: boolean,
    dsUid?: string,
    savedNonAggregatedCalculations?: ICalculationInfo[],
    dcConnId?: string,
  ) => Promise<void>;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDataset: React.Dispatch<React.SetStateAction<any>>;
}

export const DatasetAndTableList = ({
  savedCalculations,
  selectedDataSetId,
  handleDataSetChange,
  handleTableChange,
  open,
  setOpen,
  setSelectedDataset,
}: DatasetAndTableListProps) => {
  const { tabTileProps, chartProperties } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
  }));
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var selectedChartProp: IndChartPropProperties = chartProperties.properties[propKey];
  var tables = tabTileProps?.tablesForSelectedDataSets?.[selectedChartProp?.selectedDs?.id];
  var selectInput = {
    fontSize: '0.75rem',
    padding: '2px 1rem',
    maxWidth: '14rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  };

  // List of tables for a dataset, displayed
  const TableListForDs = () => {
    if (tables !== undefined) {
      return tables.map((table: IndTabRilePropsTablesForSelectedDatasets) => {
        return (
          <div
            style={{ fontSize: '0.75rem', color: palette.primary.contrastText }}
            className={`${
              table.id === selectedChartProp.selectedTable?.[selectedChartProp.selectedDs?.id]
                ? 'dsIndiTableInTileSelected'
                : 'dsIndiTableInTile'
            } ${table.table.length > 20 ? 'ellipsis' : ''}`}
            key={table.id}
            onClick={() => {
              handleTableChange(
                table,
                undefined,
                undefined,
                savedCalculations?.length > 0
                  ? savedCalculations
                      ?.filter(
                        (calculation) =>
                          !calculation?.isAggregated && calculation?.tableId === table.id,
                      )
                      ?.map((calculation) => calculation?.calculationInfo)
                  : [],
              );
            }}
          >
            {table.alias}
          </div>
        );
      });
    } else return null;
  };

  return (
    <div
      className="dataSetAndTableList"
      style={{
        padding: '0.5rem 1rem 0.5rem 0.9rem',
        minWidth: '15.625rem',
      }}
    >
      <div className="dataSetSelect" style={{ width: '100%', padding: '0' }}>
        <FormControl
          sx={{
            '& .MuiInputBase-root': {
              borderRadius: '0px',
            },
          }}
          fullWidth
          size="small"
          style={{
            background: 'white',
            fontSize: '12px',
            borderRadius: '4px',
          }}
        >
          <InputLabel
            id="selectDataSet"
            sx={{
              fontSize: '12px',
              lineHeight: '1.5rem',
              '&.Mui-focused': {
                color: '#2bb9bb',
              },
            }}
            shrink={true}
          >
            DataSet
          </InputLabel>

          <Select
            title={selectedChartProp.selectedDs.datasetName}
            label="DataSet"
            labelId="selectDataSet"
            value={selectedChartProp.selectedDs?.id ?? selectedDataSetId}
            variant="outlined"
            key={selectedDataSetId || selectedChartProp.selectedDs?.id}
            onChange={(e) => {
              handleDataSetChange(e.target.value);
            }}
            sx={{
              height: '1.5rem',
              fontSize: '0.75rem',
              color: 'primary.contrastText',

              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'primary.main',
                color: 'primary.main',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'primary.main',
                color: 'primary.main',
              },
              '&.Mui-focused .MuiSvgIcon-root ': {
                fill: '#2bb9bb !important',
              },
            }}
            notched={true}
          >
            <MenuItem
              sx={{
                fontSize: '0.75rem',
                padding: '2px 1rem',
                borderBottom: '1px solid lightgray',
              }}
              value="addNewDataset"
            >
              Add Dataset
            </MenuItem>

            {tabTileProps.selectedDataSetList.map((ds: TabTilPropsSelectedDatasetList) => {
              return (
                <MenuItem sx={selectInput} value={ds.id} key={ds.id}>
                  {ds.datasetName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>

      <div className="tileTableList">
        <div className="tablescontainerinDataviewerBottom" style={{ padding: 0 }}>
          <TableListForDs />
        </div>
      </div>
      {/* <DatasetListPopover
        showCard={open}
        setShowCard={setOpen}
        popOverTitle="Select Dataset"
        setSelectedDataset={setSelectedDataset}
      /> */}
    </div>
  );
};
